
export enum URLS{
  POLIZA = 'mis-polizas',
  RECLAMOS = 'mis-reclamaciones',
  PRODUCTOS = 'solicitar-productos',
  FACTURACIONCOP = 'facturas',
  POLIZACOP = 'polizas',
  REACLAMACIONESCOP = 'reclamaciones'
}
export interface Imenu {
  userType: number;
  links: Iservicios[];
}
export type Iservicios = {
  name: string,
  urlImg: string,
  p: string,
  h4: string,
  url: URLS
}